<div *ngIf='componentReady' class='CommunicationContent p-0 p-sm-3'>
  <div class='Breadcrumbs mb-5'>
    <div class='Breadcrumbs-items'>
      <a [routerLink]="['/campaigns']"
      >
        <mat-icon class='Breadcrumbs-icon back'
        >keyboard_backspace
        </mat-icon
        >
      </a
      >
      <a [routerLink]="['/campaigns']" class='Breadcrumbs-item first'
      >Active Campaigns</a
      >
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item first'>New Campaign</span>
      <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
      <span class='Breadcrumbs-item'>Campaign Wizard</span>
    </div>
  </div>
  <div class='CommunicationContent-info mb-4'>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Create Content</mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          <strong>INSTRUCTIONS:</strong> Now we are going to create your content.
          Retreva® will create the emails for you. However, it is important that
          you spend some time creating your attention and benefit statements.
        </p>
        <p class='font-weight-bolder'>Things to think about:</p>
        <ul>
          <li>
            Each statement should be able to stand alone or with other statements.
            They need to make sense in any particular order.
          </li>
          <li>
            All statements should focus on the benefit your service or product
            provides customers and not about why your product is superior or the
            best in the marketplace.
          </li>
          <li>
            All statements should be general and should not make statements directed
            at the contact like “your competitors” or what this will do for "you"
          </li>
        </ul>
        <p>
          Additionally, if you feel your product or service requires you attach a
          bunch of details, they should be created in bullets and Retreva® will
          attach them at the bottom of the email
        </p>
        <div class='CommunicationContent-info-help'>
          <div class='row'>
            <div class='col col-12 col-md-6'>
              <app-button
                (click)='openExamplesDialog()'
                [color]="'blue'"
                [size]="'small'"
                [style]="'outline'"
                [text]="'click here for examples'"></app-button>
            </div>
            <div class='col col-12 col-md-6'>
          <span class='CommunicationContent-info-help-hint'
          ><strong>Hint</strong>, you can usually find great content on your
            existing marketing materials or website</span
          >
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <div class='CommunicationContent-info'>
    <div class='CommunicationContent-form'>
      <div
        *ngIf='validationError'
        class='alert alert-danger alert-dismissible fade show'
        role='alert'>
        Please, fill all required fileds in red
        <button
          aria-label='Close'
          class='btn-close'
          data-bs-dismiss='alert'
          type='button'></button>
      </div>
      <form [formGroup]='formGroup'>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Select content</h5>
            <app-info-tip-button
              [type]="'select_content'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-md-8'>
                <div class='row'>
                  <div class='col col-12 col-md-6'>
                    <mat-label>Select Existing Content:</mat-label>
                  </div>
                  <div class='col col-12 col-md-6'>
                    <app-select
                      (selection)='onContentSelect($event)'
                      [defaultValue]='selection'
                      [items]='contentItems'
                      [label]='selectContentProperties.label'
                      formControlName='content_group_id'></app-select>
                  </div>
                </div>
              </div>
              <div *ngIf='campaignInfo && campaignInfo.content_group_id !== 0' class='col col-12 col-md-4 mt-3 mt-sm-0'>
                <app-request-help-button [contentGroupID]='campaignInfo.content_group_id'
                                         [contentGroupName]='campaignInfo.content_group'
                                         [disabled]='campaignInfo.content_requested'></app-request-help-button>
              </div>
            </div>
            <div *ngIf='showContentCodeControl' class='row mt-3'>
              <div class='col col-12 col-md-8'>
                <div class='row'>
                  <div class='col col-12 col-md-6'>
                    <mat-label>Content Code:</mat-label>
                  </div>
                  <div class='col col-12 col-md-6'>
                    <app-text-field
                      formControlName='content_code'
                      placeholder='Content Code'></app-text-field>
                  </div>
                </div>
              </div>
              <div class='col col-12 col-md-4'>
                <app-button
                  (click)='searchContentCode()'
                  [color]="'blue'"
                  [style]="'outline'"
                  size='normal'
                  text='Submit'></app-button>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Get started with you content:</h5>
            <app-info-tip-button
              [type]="'get_started_with_content'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-6'>
                <div class='d-flex flex-column'>
                  <p>Choose a Goal:</p>
                  <div>
                    <mat-radio-group
                      aria-label='Select a goal'
                      formControlName='goal'>
                      <mat-radio-button class='me-2' value='phone'
                      >Phone call
                      </mat-radio-button
                      >
                      <mat-radio-button class='me-2 mt-3 mt-sm-0' value='face'
                      >Meeting
                      </mat-radio-button
                      >
                      <mat-radio-button class='me-2 mt-3 mt-sm-0' value='website'
                      >Checking In
                      </mat-radio-button
                      >
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Fill in the blank:</h5>
            <app-info-tip-button
              [type]="'fill_in_the_blank'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>
                    I would like to learn more about your ______ (e.g. IT
                    infrastructure, hiring process, advertising goals, etc. DO
                    NOT CAPITALIZE, unless it would always be written with
                    capitalization.)
                  </p>
                  <app-text-field
                    formControlName='q_answer'
                    placeholder='Fill...'></app-text-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Select Greeting:</h5>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Greeting</p>
                  <div>
                    <app-select
                      (selection)='onGreetingsSelection($event)'
                      [items]='greetingsSelect.items'
                      [label]='greetingsSelect.label'
                      formControlName='greeting'></app-select>
                    <ng-container *ngIf='showCustomGreeting'>
                      <div class='mt-3 d-flex flex-column'>
                        <app-text-field
                          formControlName='custom_greeting'
                          placeholder='Enter greeting'></app-text-field>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Create an attention statement:</h5>
            <app-info-tip-button
              [type]="'attention_statement'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Why should customer buy your service/product ?</p>
                  <div>
                    <textarea #attention [class.has-error]="
                        formGroup.get('attention').touched &&
                        formGroup.get('attention').hasError('required')
                      " cols='10' formControlName='attention' rows='10'></textarea>
                    <div class='d-flex flex-row align-items-center'>
                      <div *ngIf='variables.length > 0' class='flex-grow-0'>
                        <app-select
                          (selection)="onVariableSelect($event, 'attention')"
                          [items]='variables'
                          [label]="'Insert Variable'"></app-select>
                      </div>
                      <p
                        (click)="insertHyperlink('attention')"
                        class='insert-hyper-link ms-3'>
                        Insert Hyperlink
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Create 2 benefit statements:</h5>
            <app-info-tip-button
              [type]="'explain_benefits'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <div>
                    <p>Benefit 1:</p>
                    <textarea #benefit_1 [class.has-error]="
                        formGroup.get('benefit_1').touched &&
                        formGroup.get('benefit_1').hasError('required')
                      " cols='10' formControlName='benefit_1' rows='10'></textarea>
                    <div class='d-flex flex-row align-items-center'>
                      <div *ngIf='variables.length > 0' class='flex-grow-0'>
                        <app-select
                          (selection)="onVariableSelect($event, 'benefit_1')"
                          [items]='variables'
                          [label]="'Insert Variable'"></app-select>
                      </div>
                      <p
                        (click)="insertHyperlink('benefit_1')"
                        class='insert-hyper-link ms-3'>
                        Insert Hyperlink
                      </p>
                    </div>
                  </div>
                  <div class='mt-3'>
                    <p>Benefit 2:</p>
                    <textarea #benefit_2 [class.has-error]="
                        formGroup.get('benefit_2').touched &&
                        formGroup.get('benefit_2').hasError('required')
                      " cols='10' formControlName='benefit_2' rows='10'></textarea>
                    <div class='d-flex flex-row align-items-center'>
                      <div *ngIf='variables.length > 0' class='flex-grow-0'>
                        <app-select
                          (selection)="onVariableSelect($event, 'benefit_2')"
                          [items]='variables'
                          [label]="'Insert Variable'"></app-select>
                      </div>
                      <p
                        (click)="insertHyperlink('benefit_2')"
                        class='insert-hyper-link ms-3'>
                        Insert Hyperlink
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Detailed Section:</h5>
            <app-info-tip-button
              [type]="'detailed_section'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Details</p>
                  <div>
                    <textarea #details [class.has-error]="
                        formGroup.get('details').touched &&
                        formGroup.get('details').hasError('required')
                      " cols='10' formControlName='details' rows='10'></textarea>
                    <div class='d-flex flex-row align-items-center'>
                      <div *ngIf='variables.length > 0' class='flex-grow-0'>
                        <app-select
                          (selection)="onVariableSelect($event, 'details')"
                          [items]='variables'
                          [label]="'Insert Variable'"></app-select>
                      </div>
                      <p
                        (click)="insertHyperlink('details')"
                        class='insert-hyper-link ms-3'>
                        Insert Hyperlink
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class='CommunicationContent-form-row'>
          <div class='CommunicationContent-form-row-header d-flex flex-row'>
            <h5>Provide an email signature:</h5>
            <app-info-tip-button
              [type]="'provide_signature'"></app-info-tip-button>
          </div>
          <div class='CommunicationContent-form-row-content'>
            <div class='row'>
              <div class='col col-12 col-sm-6'>
                <div class='d-flex flex-column'>
                  <p>Signature</p>
                  <div>
                    <app-editor formControlName='signature'></app-editor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class='CommunicationContent-form-row d-flex flex-row justify-content-end'>
          <app-button
            [color]='backButton.color'
            [route]='backButton.route'
            [size]='backButton.size'
            [style]='backButton.style'
            [text]='backButton.text'
            class='CommunicationContent-form-controls-button'></app-button>
          <app-button
            [Click]='previewButton.onClick'
            [color]='previewButton.color'
            [observeApi]='true'
            [size]='previewButton.size'
            [style]='previewButton.style'
            [text]='previewButton.text'
            class='CommunicationContent-form-controls-button'></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
